/**
 * 拣选任务 Service层 - 业务逻辑层 + Mock 适配
 * 页面组件只调用此 Service 层,不直接调用 API
 */

import { config } from '../../config';
import * as pickingMock from '../../mocks/picking';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';
import type { ApiResponse, PageData } from '../../types/common';
import type {
  PickingTaskDTO,
  PickingTaskDetailDTO,
  PickingResultItemDTO,
  QueryPickingTaskPageRequest,
  QueryPlanDetailsRequest,
  QueryPickingResultsRequest,
  AssignPickingTaskRequest,
} from '../../types/picking/pickingTask';

/**
 * 分页查询拣选任务列表
 */
export async function pagePickingTask(
  params: QueryPickingTaskPageRequest
): Promise<ApiResponse<PageData<PickingTaskDTO>>> {
  if (config.mock) {
    return pickingMock.mockPagePickingTask(params);
  }

  return httpClient.post(API_ENDPOINTS.PICKING_TASK.PAGE, params);
}

/**
 * 查询拣选任务详情
 */
export async function getPickingTaskByCode(
  taskCode: string
): Promise<ApiResponse<PickingTaskDTO>> {
  if (config.mock) {
    return pickingMock.mockGetPickingTaskByCode(taskCode);
  }

  return httpClient.get(`${API_ENDPOINTS.PICKING_TASK.BASE}/${taskCode}`);
}

/**
 * 查询拣选计划明细
 */
export async function pagePlanDetails(
  taskCode: string,
  params: QueryPlanDetailsRequest
): Promise<ApiResponse<PageData<PickingTaskDetailDTO>>> {
  if (config.mock) {
    return pickingMock.mockPagePlanDetails(taskCode, params);
  }

  return httpClient.post(`${API_ENDPOINTS.PICKING_TASK.BASE}/${taskCode}/plan-details`, params);
}

/**
 * 查询拣货结果
 */
export async function pagePickingResults(
  taskCode: string,
  params: QueryPickingResultsRequest
): Promise<ApiResponse<PageData<PickingResultItemDTO>>> {
  if (config.mock) {
    return pickingMock.mockPagePickingResults(taskCode, params);
  }

  return httpClient.post(`${API_ENDPOINTS.PICKING_TASK.BASE}/${taskCode}/picking-results`, params);
}

/**
 * 指派拣选任务
 */
export async function assignPickingTask(
  data: AssignPickingTaskRequest
): Promise<ApiResponse<null>> {
  if (config.mock) {
    return pickingMock.mockAssignPickingTask(data);
  }

  return httpClient.post(API_ENDPOINTS.PICKING_TASK.ASSIGN, data);
}

/**
 * 导出拣选任务列表
 */
export async function exportPickingTask(
  params: QueryPickingTaskPageRequest
): Promise<ApiResponse<{ downloadUrl: string; fileName: string }>> {
  if (config.mock) {
    return pickingMock.mockExportPickingTask(params);
  }

  return httpClient.post(API_ENDPOINTS.PICKING_TASK.EXPORT, params);
}
